<template>
    <div class="pie-chart-wrapper">
        <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
            <g :transform="`translate(${cx}, ${cy})`">
                <path
                    v-for="(slice, index) in slices"
                    :key="index"
                    :d="slice.path"
                    :fill="slice.color"
                    :stroke="'#fff'"
                    stroke-width="2"
                    class="pie-slice"
                    @mouseenter="hoveredIndex = index"
                    @mouseleave="hoveredIndex = null"
                    :style="hoveredIndex === index ? 'opacity:0.85;transform:scale(1.03);transform-origin:center;' : 'opacity:1'"
                >
                    <title>{{ slice.label }}: {{ slice.value }}% ({{ slice.count }})</title>
                </path>
            </g>
        </svg>
        <!-- Tooltip flotante -->
        <div
            v-if="hoveredIndex !== null && slices[hoveredIndex]"
            class="pie-tooltip"
        >
            <span class="font-semibold">{{ slices[hoveredIndex].label }}</span><br />
            {{ slices[hoveredIndex].count }} tickets &mdash; {{ slices[hoveredIndex].value }}%
        </div>
    </div>
</template>

<script>
const CHART_COLORS = [
    '#4F46E5', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6',
    '#06B6D4', '#F97316', '#84CC16', '#EC4899', '#14B8A6',
    '#6366F1', '#A3E635', '#FB923C', '#F43F5E', '#22D3EE',
];

export default {
    name: 'PieChart',
    props: {
        data: {
            type: Array,
            default: () => [],
            // Each item: { name: String, cantidad: Number, porcentaje: Number }
        },
        size: {
            type: Number,
            default: 220,
        },
        colors: {
            type: Array,
            default: () => CHART_COLORS,
        },
    },
    data() {
        return {
            hoveredIndex: null,
        };
    },
    computed: {
        cx() { return this.size / 2; },
        cy() { return this.size / 2; },
        radius() { return this.size / 2 - 10; },
        total() {
            return this.data.reduce((sum, d) => sum + (d.cantidad || 0), 0);
        },
        slices() {
            if (!this.data.length || this.total === 0) return [];

            const slices = [];
            let currentAngle = -Math.PI / 2; // Start from top

            this.data.forEach((item, index) => {
                const value = item.cantidad || 0;
                const angle = (value / this.total) * 2 * Math.PI;
                const startAngle = currentAngle;
                const endAngle   = currentAngle + angle;

                const x1 = Math.cos(startAngle) * this.radius;
                const y1 = Math.sin(startAngle) * this.radius;
                const x2 = Math.cos(endAngle) * this.radius;
                const y2 = Math.sin(endAngle) * this.radius;

                const largeArcFlag = angle > Math.PI ? 1 : 0;

                const path = [
                    `M 0 0`,
                    `L ${x1} ${y1}`,
                    `A ${this.radius} ${this.radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
                    `Z`,
                ].join(' ');

                slices.push({
                    path,
                    color: this.colors[index % this.colors.length],
                    label: item.name,
                    value: item.porcentaje,
                    count: value,
                });

                currentAngle = endAngle;
            });

            return slices;
        },
    },
};
</script>

<style scoped>
.pie-chart-wrapper {
    position: relative;
    display: inline-block;
}
.pie-slice {
    transition: opacity 0.15s ease, transform 0.15s ease;
    cursor: default;
}
.pie-tooltip {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(15, 23, 42, 0.88);
    color: #fff;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 13px;
    pointer-events: none;
    white-space: nowrap;
    z-index: 10;
    text-align: center;
    line-height: 1.5;
}
</style>
